var React = require('react');

function UiChevronDown (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Chevron Down"),React.createElement("g",{"key":1},React.createElement("g",null,React.createElement("polygon",{"points":"32.8,0 24.2,7.8 15.5,0 0,0 23.9,21.6 47.8,0 32.8,0 \t\t"})))]);
}

UiChevronDown.defaultProps = {"role":"presentation","version":"1.1","x":"0px","y":"0px","viewBox":"0 0 47.8 21.6","style":{"enableBackground":"new 0 0 47.8 21.6"},"xmlSpace":"preserve"};

module.exports = UiChevronDown;

UiChevronDown.default = UiChevronDown;
